// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1c_rs","row":"styles_row__2FOGa"};